import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("setIs24HrShiftInStore", function setIs24HrShiftInStore(is24HrShift: boolean) {
    shiftEditorViewState().is24HrShift = is24HrShift;
});
